import type { UserProfile } from './authTypes'

export const saveUserProfile = (profile: UserProfile) => {
  localStorage.setItem('userProfile', JSON.stringify(profile))
}

export const clearAuthStorage = () => {
  localStorage.removeItem('userProfile')
  localStorage.removeItem('isDemoUser')
  localStorage.removeItem('auth_token')
  localStorage.removeItem('auth_user')
  localStorage.removeItem('refresh_token')
}
